// extracted by mini-css-extract-plugin
export default {"formError":"FormError-module__formError___kkjOh"};